import '../style/currency-input-DZiebg1U.css'
import { defineComponent as E, ref as $, toRef as O, computed as s, openBlock as p, createElementBlock as f, normalizeClass as P, unref as n, createVNode as r, createCommentVNode as S, withCtx as m, withModifiers as A, mergeProps as y } from "vue";
import b from "./coin.js";
import F from "./input-number.js";
import { Select as M } from "./select.js";
import I from "./spinner.js";
import { UPDATE_MODEL_VALUE as v } from "./constant/events.js";
import { useFormItem as R } from "./hooks/useFormItem.js";
import { useInputClass as U } from "./hooks/useInputClass.js";
import { useInputSize as L } from "./hooks/useInputSize.js";
const N = {
  key: 0,
  class: "e-currency-input__loading-mask"
}, W = /* @__PURE__ */ E({
  name: "e-currency-input",
  __name: "currency-input",
  props: {
    modelValue: {},
    amount: {},
    currency: {},
    currencyOptions: {},
    fallbackPrecision: { default: 8 },
    filterable: { type: Boolean },
    clearable: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    selectDisabled: { type: Boolean },
    inputDisabled: { type: Boolean },
    placeholder: {},
    isError: { type: Boolean },
    loading: { type: Boolean },
    min: {},
    max: {},
    size: {},
    showMaxButton: { type: Boolean },
    limitRange: { type: Boolean }
  },
  emits: ["update:modelValue", "update:amount", "update:currency"],
  setup(z, { emit: B }) {
    const o = z, i = B, u = $(!1), { formSize: C } = R(), { actualSize: t } = L({ formSize: C, propSize: O(o, "size") }), g = s(() => o.modelValue?.amount ?? o.amount ?? ""), c = s(() => o.modelValue?.currency ?? o.currency ?? ""), V = s(() => o.currencyOptions.find((l) => l.value === c.value)?.precision ?? o.fallbackPrecision), h = s(() => ({
      disabled: o.inputDisabled,
      error: o.isError,
      focus: u.value
    })), { inputClass: k } = U("currency-input", h);
    function d(e) {
      u.value = e;
    }
    function w(e) {
      o.modelValue && i(v, {
        amount: o.modelValue.amount,
        currency: e
      }), i("update:currency", e);
    }
    function D(e) {
      o.modelValue && i(v, {
        amount: e,
        currency: o.modelValue.currency
      }), i("update:amount", e);
    }
    return (e, l) => (p(), f("div", {
      class: P(n(k))
    }, [
      e.loading ? (p(), f("div", N, [
        r(n(I))
      ])) : S("", !0),
      r(n(M), {
        id: void 0,
        "model-value": c.value,
        "offset-distance": "0",
        placement: "bottom-end",
        size: n(t),
        "aria-label": "currency",
        options: e.currencyOptions,
        filterable: e.filterable,
        disabled: e.selectDisabled,
        "is-error": e.isError,
        lazy: e.lazy,
        "align-right": "",
        focused: u.value,
        onChange: w
      }, {
        prefix: m(() => [
          r(n(F), {
            "model-value": g.value,
            size: n(t),
            disabled: e.inputDisabled,
            precision: V.value,
            placeholder: e.placeholder,
            min: e.min,
            max: e.max,
            "limit-range": e.limitRange,
            "show-max-button": e.showMaxButton,
            clearable: e.clearable,
            onClick: l[0] || (l[0] = A(() => {
            }, ["stop"])),
            onFocus: l[1] || (l[1] = (a) => d(!0)),
            onBlur: l[2] || (l[2] = (a) => d(!1)),
            "onUpdate:modelValue": D
          }, null, 8, ["model-value", "size", "disabled", "precision", "placeholder", "min", "max", "limit-range", "show-max-button", "clearable"])
        ]),
        selected: m(({ selected: a }) => [
          r(n(b), y({
            coin: c.value,
            size: n(t),
            "desc-layout": "vertical"
          }, a), null, 16, ["coin", "size"])
        ]),
        default: m(({ option: a }) => [
          r(n(b), y({
            coin: `${a.value}`,
            size: n(t)
          }, a), null, 16, ["coin", "size"])
        ]),
        _: 1
      }, 8, ["model-value", "size", "options", "filterable", "disabled", "is-error", "lazy", "focused"])
    ], 2));
  }
});
export {
  W as default
};
//# sourceMappingURL=currency-input.js.map
